(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmReferralSourceType', CrmReferralSourceType);

    CrmReferralSourceType.$inject = ['$resource'];

    function CrmReferralSourceType ($resource) {
        var resourceUrl =  'api/crm-referral-source-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
